
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { BatchEntry } from '../../../../../models/attendance/batchEntry';

@Injectable()
export class BatchEntryListProvider implements Resolve<any> {
    batchEntry: BatchEntry[];
    batchEntryEdit: BatchEntry;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.batchEntryEdit = this.state?.currentBatchEntry;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
            this.pageOptions.fieldSort = 'opened';
            this.pageOptions.sortDirection = 'desc';
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'opened';
            this.pageOptions.sortDirection = 'desc';
        }
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    get(id: number): Observable<BatchEntry> {
        if (!id) {
            return null;
        }
        return this.gw.get('batchEntry/:id', { id: id });
    }

    get currentBatchEntry(): BatchEntry {
        return this.batchEntryEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('batchEntry/').subscribe({
                next: (res: HttpResponse<any>) => {
                    this.batchEntry = res.body;
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('batchEntry/search', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (!CwUtils.compare(this.batchEntry, res.body.content) && res.body.content.length > 0) {
                        this.batchEntry = res.body.content;
                        this.onDataChanged.next(this.batchEntry);
                    }
                    else {
                        this.batchEntry = res.body.content;
                    };
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }
    getPageSimpleList(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('batchEntry/search/simple', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPagePatientSelect(filter): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('batchEntry/search/patient', filter).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    /*
    * Batch-Entry-Result
    */
    getPageBatchEntryItem(batchEntryId, pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`batchEntry/batchEntryItem/${batchEntryId}`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }
    /*
    * Batch-Entry-spect
    */
    getBatchEntrySpectId(batchEntryItemId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`batchEntry/batch-entry-spec/${batchEntryItemId}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    /*
    * Batch-Entry-filter
    */
    getBatchEntryFilter(batchEntryId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`batchEntry/${batchEntryId}/batch-entry-filter/list`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }
    // {batchEntryId}/batch-entry-filter/list

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

